import React, { FC, ReactNode } from 'react';
import connectionErrorCard from 'assets/connection_error_icon.svg';
import failureCard from 'assets/failure_card.svg';
import warningCard from 'assets/warning_card.png';

type ErrorIcon = {
  src: string;
  alt: string;
};

const MESSAGE_TYPES: Record<
  string,
  {
    defaultIcon: ErrorIcon;
    defaultTitle: string;
    className: string;
  }
> = {
  error: {
    defaultIcon: {
      src: failureCard,
      alt: 'Card failure icon',
    },
    defaultTitle: 'Failed to pay',
    className: 'failure-message',
  },
  warning: {
    defaultIcon: {
      src: warningCard,
      alt: 'Warning icon',
    },
    defaultTitle: 'Warning',
    className: 'failure-message warning-message',
  },
};

const CUSTOM_ICONS: Record<string, ErrorIcon> = {
  connectionError: {
    src: connectionErrorCard,
    alt: 'Connection error icon',
  },
};

interface PaymentErrorProps {
  title?: string;
  errorMessage: string;
  type?: keyof typeof MESSAGE_TYPES;
  customIcon?: keyof typeof CUSTOM_ICONS;
  children?: ReactNode;
}

const PaymentError: FC<PaymentErrorProps> = ({ title, errorMessage, type = 'error', customIcon, children }) => {
  const { defaultIcon, defaultTitle, className } = MESSAGE_TYPES[type] ?? MESSAGE_TYPES.error;
  const errorIcon = customIcon ? CUSTOM_ICONS[customIcon] : defaultIcon;
  const errorTitle = title ?? defaultTitle;

  return (
    <div className={className}>
      <img src={errorIcon.src} alt={errorIcon.alt} />
      <div>
        <h6>{errorTitle}</h6>
        {errorMessage.split('\n').map((line, idx) => (
          <p key={idx}>{line}</p>
        ))}
        <span>{children}</span>
      </div>
    </div>
  );
};

export default PaymentError;
